export const JoinMeetingI18n = {
	zh: {
		'join-meeting-copy': '复制',
		'join-meeting-copy-btn': '复制会议信息',
		'join-meeting-btn-word': '会议已设置密码，请联系主持人获取',
		'join-meeting-btn': '加入会议',
		'join-meeting-invite-title': '邀请您参加会议 <br/> 会议主题：',
		'join-meeting-invite-time': '<br/> 会议时间：',
		'join-meeting-invite-tip': '<br/> 点击链接直接加入会议： <br/> ',
		'join-meeting-invite-id': '<br/> 会议ID：',
		'join-meeting-invite-pw': '<br/> 会议密码：',
		'join-meeting-copy-info-1': '会议信息已复制',
		'join-meeting-copy-info-2': '会议号已复制',
		'join-meeting-status-1': '未开始',
		'join-meeting-status-2': '进行中',
		'join-meeting-status-3': '已结束',
		'join-meeting-status-4': '已删除'
	},
	en: {
		'join-meeting-copy': 'copy',
		'join-meeting-copy-btn': 'Copy meeting information',
		'join-meeting-btn-word': 'A password has been set for the meeting, please contact the host to obtain it.',
		'join-meeting-btn': 'Join Meeting',
		'join-meeting-invite-title': 'invited you join the meeting <br/> Meeting Topic:',
		'join-meeting-invite-time': '<br/> Meeting Time:',
		'join-meeting-invite-tip': '<br/> Click the link to join the meeting: <br/> ',
		'join-meeting-invite-id': '<br/> Meeting ID：',
		'join-meeting-invite-pw': '<br/> Meeting Password:',
		'join-meeting-copy-info-1': 'Meeting information copied',
		'join-meeting-copy-info-2': 'Meeting code copied',
		'join-meeting-status-1': 'Coming soon',
		'join-meeting-status-2': 'In progress',
		'join-meeting-status-3': 'Over',
		'join-meeting-status-4': 'Deleted'
	},
}